import { useCallback, useState } from "react";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { SLOTS_APIS } from "@/api_framework/api_config";

AxiosCurlirize(axios, () => {});

type IExemptionEligibleResponse = {
  status: boolean;
  message: string;
  data?: any;
};

type IAPIResponse = {
  status: boolean;
  message: string;
};

export const useExemptionEligibleAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const dispatch=useAppDispatch();
  const [data, setData] = useState<any>(null);

  const execute = useCallback(
    async (userId: string, clinicId: string): Promise<IAPIResponse | undefined> => {
      try {

        const accessToken = localStorage.getItem(
          configuration.localStorage.ACCESS_TOKEN.key
        );

        const response: IAPIResponse = await axios
          .get(
            `${SLOTS_APIS?.CART_EXCEPTIONS?.baseURL}`,
            {
              params: {
                user_id: userId,
                clinic_id: clinicId,
              },
              headers: {
                Authorization: `${accessToken}`,
                "Content-Type": "application/json",
              },
            }
          )
          .then((res: AxiosResponse<IExemptionEligibleResponse>) => {
            if (res.data.status) {
              setData(res.data.data);
              return { status: true, message: "success" };
            } else {
              setData(null);
              return { status: false, message: res.data.message };
            }
          })
          .catch((e: AxiosError) => {
            if (e.config) {
              sendCurl(e.config["curlCommand"]);
            }
            return { status: false, message: "api_failed" };
          });

        return response;
      } catch (e) {
        captureError(e);
      }
    },
    [dispatch]
  );

  return { data , execute };
};
